import { format } from 'date-fns';

export const parseServerDate = (isoString: string): Date => {
  const date = new Date(isoString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

export const formatDateRange = (startDate: string, endDate: string): string => {
  const start = parseServerDate(startDate);
  const end = parseServerDate(endDate);
  return `${format(start, 'MM/dd/yyyy')} - ${format(end, 'MM/dd/yyyy')}`;
};
